import { ConsoleLog } from '../business/console-log';

export class ConsoleService {
    private static readonly ORANGE = '#bb4d00';

    private static readonly BLUE = '#1976d2';

    private static readonly RED = '#d32f2f';

    public static log(log: ConsoleLog): void {
        switch (log.level) {
            case 'debug':
                this.debug(log.className, log.message);
                break;
            case 'info':
                this.info(log.className, log.message);
                break;
            case 'error':
                this.error(log.className, log.message);
                break;
            default:
                this.debug(log.className, log.message);
                break;
        }
    }

    private static debug(className: string, message: string): void {
        ConsoleService.print(className, message, ConsoleService.ORANGE);
    }

    private static info(className: string, message: string): void {
        ConsoleService.print(className, message, ConsoleService.BLUE);
    }

    private static error(className: string, message: string): void {
        ConsoleService.print(className, message, ConsoleService.RED);
    }

    private static print(className: string, message: string, color: string) {
        // eslint-disable-next-line no-console
        console.log(
            `%c${className} %c${message}`,
            `background: ${color}; color: #fff; padding: 2px 10px`,
            `padding: 1px 5px; border: 1px solid ${color};`,
        );
    }
}
